/**
 * Service Paiements - API Tracking (read-only list/detail)
 * GET /api/v1/payments/ , GET /api/v1/payments/{id}/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingPayment {
  id: string;
  student: string;
  student_id: string;
  student_user_id: number | null;
  student_name: string | null;
  parent: number;
  parent_id: number;
  parent_name: string | null;
  payer_name: string;
  amount: string;
  payment_method: string;
  payment_method_display: string;
  phone_number: string;
  status: string;
  status_display: string;
  transaction_id: string | null;
  created_at: string;
  updated_at: string;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

export async function fetchTrackingPayments(
  accessToken: string | undefined
): Promise<TrackingPayment[]> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingPayment[] | { results: TrackingPayment[] }>("/api/v1/payments/");
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) return (data as { results: TrackingPayment[] }).results;
  return [];
}

export async function fetchTrackingPayment(
  accessToken: string | undefined,
  id: string
): Promise<TrackingPayment> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingPayment>(`/api/v1/payments/${id}/`);
  return data;
}
